import { apiClient } from '@devd-client/api';
import { getToken, getOrgId } from '@devd-client/devd/auth';
import type { ActivityLogPageResponse } from '../helpers/ActivityLog.types';

export const getActivityLogPage = (): Promise<ActivityLogPageResponse> =>
  apiClient(`/v2/account/org/${getOrgId()}/page/Activity`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
